import Foreign from './Foreign';

export default Foreign;
